import { useTranslation } from "react-i18next";
import ContentExternalLink from "../../../../components/ContentExternalLink";
import type { ArticlePageArticle } from "../../hooks/useArticleData";

interface ArticleSectionEditorialProps {
  article: ArticlePageArticle;
  handleViewArticleSource: () => void;
}

export function ArticleSectionEditorial({
  article,
  handleViewArticleSource,
}: ArticleSectionEditorialProps) {
  const edito = article.edito;
  const { t } = useTranslation();

  if (!edito) return null;

  return (
    <section data-gtm-section="editorial" data-gtm-order="13">
      <ContentExternalLink
        href={edito}
        heading={t("To go further")}
        text={t("Read the editorial")}
        isEditorial
        onClick={handleViewArticleSource}
      />
    </section>
  );
}
